var _defs, _path, _path2, _path3, _path4, _circle, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Delivery_svg__b0aa706e-e3fe-4306-a607-606ad88eb8b1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Delivery_svg__a4050842-3ead-4f93-a143-8c4b4a035e6d",
    "data-name": "Delivery"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Delivery_svg__b0aa706e-e3fe-4306-a607-606ad88eb8b1",
    d: "m102.72 148.35-11.88-11.88-4.84-4.88-.06-.05 11-11L107.5 110l36.05-36c.59-.59 1.2-1.15 1.82-1.67a27.75 27.75 0 0 1 17.87-6.49c7.13 0 25 6.46 25 6.46s5.49 28.32-3.69 39.26c-.52.62-1.08 1.23-1.67 1.82L136.3 159.9l-11 11-4.82-4.82-12-12M140.18 199.31 125.34 171l21.59-21.58c23.07 20.03-6.75 49.89-6.75 49.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Delivery_svg__b0aa706e-e3fe-4306-a607-606ad88eb8b1",
    d: "M57.63 116.76 86 131.59 107.55 110c-20.06-23.1-49.92 6.76-49.92 6.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Delivery_svg__b0aa706e-e3fe-4306-a607-606ad88eb8b1",
    d: "M111.49 123.06h0a4.08 4.08 0 0 1 4.08 4.08v40.47h0-8.15 0v-40.47a4.08 4.08 0 0 1 4.08-4.08Z",
    transform: "rotate(-135 111.491 145.336)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Delivery_svg__b0aa706e-e3fe-4306-a607-606ad88eb8b1",
    d: "m96.92 120.52.06.06 16.75 16.76M119.49 143.09l16.81 16.81M184.63 111.49l-39.3-39.29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Delivery_svg__b0aa706e-e3fe-4306-a607-606ad88eb8b1",
    cx: 148.15,
    cy: 108.68,
    r: 12.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Delivery_svg__b0aa706e-e3fe-4306-a607-606ad88eb8b1",
    d: "M90.84 136.47a39.14 39.14 0 0 0-18.63 11c-16.14 17.53-7.8 43.53-7.4 44.66 1.17.4 27.18 8.74 44.67-7.41a39 39 0 0 0 11-18.63"
  }))));
};

export default SvgDelivery;